(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('GraphController', function(
            $filter,
            $sce,
            $scope,
            $stateParams,
            $timeout,
            ContractorFilter,
            Graph,
            DictionariesService,
            EventService,
            Unavailability
        ) {
            var vm = this;

            $scope.$watch('graph.graphFilter.day', function(date) {
                vm.dayFormatted = date.format('DD-MM-YYYY');
            });

            $scope.$on('languageChange', function() {
                vm.updateDay();
            });

            $scope.$on('contractorsConfigSet', function(event, contractorsConfig) {
                vm.contractorsConfig = contractorsConfig;
                if ($stateParams.contractor !== 'all') {
                    vm.loadAll();
                }
            });

            vm.tab = 'DAY';
            vm.summary = [];
            vm.timestamps = [];
            vm.powerplants = [];
            vm.selectedGranulation = 'DAY';
            vm.years = DictionariesService.getYears();
            vm.months = DictionariesService.getMonths();
            vm.granulations = DictionariesService.getGranulations();
            vm.contractorsConfig = ContractorFilter.getContractorsConfig();

            vm.graphFilter = {
                week: null,
                day: moment().startOf('day'),
                year: {
                    id: moment().get('year')
                },
                month: {
                    id: moment().get('month')
                }
            };

            vm.isActiveTab = function(granulation) {
                return vm.tab === granulation.id;
            };

            vm.updateWeeks = function() {
                vm.weeks = Graph.getWeeks(vm.graphFilter.year.id);

                var currentWeek = _.find(vm.weeks, function(week) {
                    return week.currentWeek;
                });

                vm.graphFilter.week = currentWeek;
            };

            vm.getPeriodStart = function() {
                if (vm.selectedGranulation === 'DAY') {
                    return moment(vm.graphFilter.day, 'DD/MM/YYYY')
                        .startOf('day')
                        .format('YYYY/MM/DD');
                }
                if (vm.selectedGranulation === 'WEEK') {
                    return vm.graphFilter.week.date.format('YYYY/MM/DD');
                }
                if (vm.selectedGranulation === 'MONTH') {
                    return moment({
                        year: vm.graphFilter.year.id,
                        month: vm.graphFilter.month.id,
                        day: 1
                    }).format('YYYY/MM/DD');
                }
                return moment({
                    year: vm.graphFilter.year.id,
                    month: 0,
                    day: 1
                }).format('YYYY/MM/DD');
            };

            vm.loadAll = function() {
                if ($stateParams.contractor === 'all' || !_.isEmpty(vm.contractorsConfig)) {
                    var queryParams = {
                        mode: 'ENERGY',
                        granulation: vm.selectedGranulation,
                        periodStart: vm.getPeriodStart()
                    };

                    var foundContractor = _.find(vm.contractorsConfig, function(contractor) {
                        return contractor.shortName === $stateParams.contractor;
                    });

                    if (!_.isEmpty(foundContractor)) {
                        queryParams.marketParticipantCode = foundContractor.eicCode;
                    }

                    Unavailability.query(queryParams, function(result) {
                        var powerplants = result.powerplants;
                        Graph.decorateWithStyles(powerplants);
                        Graph.decorateWithVisibility(powerplants);
                        vm.powerplants = powerplants;
                        vm.timestamps = Graph.getDecoratedTimestamps(result.timestamps, vm.selectedGranulation);
                        vm.summary = result.summary;
                    }).$promise.then(function() {
                        $timeout(function() {
                            Graph.setTablePosition();
                        });
                    });
                }
            };

            vm.changeGranulation = function(granulation, $event) {
                $event.preventDefault();
                vm.selectedGranulation = granulation.id;
                vm.tab = granulation.id;
            };

            vm.toggleBlocks = function(groupId) {
                Graph.toggleBlocks(vm.powerplants, groupId);

                $timeout(function() {
                    Graph.setControlsScroll();
                });
            };

            vm.scrollRightTable = function() {
                EventService.scrollTable(5);
            };

            vm.scrollLeftTable = function() {
                EventService.scrollTable(-5);
            };

            vm.stopScroll = function() {
                EventService.stopScroll();
            };

            vm.updateDay = function() {
                var momented = moment(vm.dayFormatted, 'DD-MM-YYYY');
                if (momented.isValid()) {
                    vm.graphFilter.day = momented.endOf('day');
                }
            };

            vm.getDataForTooltip = function(tooltips) {
                var tooltip = '';
                var start;
                var stop;
                var block;

                if (!_.isEmpty(tooltips)) {
                    _.each(tooltips, function(el) {
                        block = $filter('translate')('remitEventsApp.graph.tooltip.asset') + ': <b>' + _.escape(el.asset) + '</b> ';
                        start =
                            $filter('translate')('remitEventsApp.graph.tooltip.start') +
                            ': <b>' +
                            moment(el.eventStart).format('DD-MM-YYYY HH:mm') +
                            '</b> ';
                        stop =
                            $filter('translate')('remitEventsApp.graph.tooltip.stop') +
                            ': <b>' +
                            moment(el.eventStop).format('DD-MM-YYYY HH:mm') +
                            '</b>';
                        tooltip +=
                            '<div class="row-tooltip">' +
                            block +
                            $filter('translate')('remitEventsApp.graph.tooltip.unavailable') +
                            ': <b>' +
                            el.unavailability +
                            '</b> ' +
                            $filter('translate')('remitEventsApp.graph.tooltip.available') +
                            ': <b>' +
                            el.availablePower +
                            '</b> ' +
                            start +
                            stop +
                            '</div>';
                    });
                }

                return tooltip;
            };

            vm.$onInit = function() {
                Graph.getLastEventYear()
                    .query()
                    .$promise.then(function(response) {
                        vm.years = _.map(_.range(2011, Math.max(2019, parseInt(response.year)) + 1), function(value) {
                            return {
                                id: value,
                                label: value
                            };
                        });
                    });

                vm.loadAll();
                vm.updateWeeks();
            };
        });
})();
